import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type DeleteIFRSQuestionExhibitAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: any;
};

export const DeleteIFRSQuestionExhibit = async (
  questionId: string,
  exhibitId: string
): Promise<DeleteIFRSQuestionExhibitAPIResponse> => {
  try {
    const response = await axios.delete(`/ifrs-question/${questionId}/exhibits/${exhibitId}`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};


